export default "__VITE_ASSET__X5kC50lq__"